import { useMemo } from "react";
import { ActivityIndicator } from "react-native";
import {
  CartesianGrid,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LineChart,
} from "recharts";

interface CallsLast7Props {
  data?: Array<{ date: string; count: number }>;
  loading?: boolean;
}

const CallsLast7 = ({ data, loading }: CallsLast7Props) => {
  const callsData = useMemo(() => {
    const last7Days = [];
    for (let i = 6; i >= 1; i--) {
      const date = new Date();
      date.setDate(date.getDate() - i);
      const day = date.getDate();
      const month = date.toLocaleDateString("en-US", { month: "short" });
      const label = `${day} ${month}`;
      const matchingData = data?.find((item) => {
        const itemDate = item.date.split("T")[0];
        return itemDate === date.toISOString().split("T")[0];
      });
      last7Days.push({
        name: label,
        Calls: matchingData?.count || 0,
      });
    }

    return last7Days;
  }, [data]);

  return (
    <div className="w-full bg-white text-gray-800 rounded-lg p-6 border border-gray-200">
      <h2 className="text-xl font-semibold mb-4">
        Calls {loading ? "Loading..." : ""}
      </h2>
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <ActivityIndicator size="large" color="#6b7280" />
        </div>
      ) : (
        <div className="h-[276px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={callsData}
              margin={{ top: 5, right: 20, left: -10, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
              <XAxis
                dataKey="name"
                tick={{ fill: "#6b7280", fontSize: 12 }}
                stroke="#d1d5db"
              />
              <YAxis
                tick={{ fill: "#6b7280", fontSize: 12 }}
                stroke="#d1d5db"
              />
              <Line
                type="linear"
                dataKey="Calls"
                stroke="#8884d8"
                strokeWidth={2}
                dot={false}
                activeDot={false}
                isAnimationActive={false}
                animationDuration={0}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
};

export default CallsLast7;
